// See https://tools.ietf.org/html/rfc7807
class ProblemDetails extends Error {
    title;
    detail;
    status;
    type = "Error";
    constructor(title, detail, status) {
        super();
        this.title = title;
        this.detail = detail;
        this.status = status;
    }
    withDetail(detail) {
        return new ProblemDetails(this.title, detail, this.status);
    }
}
export const errorTypes = {
    "Unknown": new ProblemDetails("An unknown error has occurred", "An unknown error has occurred.", 500),
    "InvalidRequest": new ProblemDetails("The request associated to the operation is syntactically invalid or includes wrong content", "", 400),
    "NotFound": new ProblemDetails("The requested resource was not found", "", 404),
    "InternalError": new ProblemDetails("There has been an error during the operation execution", "", 500)
};
